import { AdminPortalKeys, Namespace } from '@i18n/translations';
import { cn } from '@my-medication/shared-components/shadcn/utils';
import { type FunctionComponent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { type FooterProps } from './Footer.types';

const Footer: FunctionComponent<FooterProps> = ({ footerText, dataTestid, className }) => {
  const { t } = useTranslation(Namespace.AdminPortal);
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <footer className={cn('box-border w-full bg-secondary-800 px-4 pt-16 pb-4', className)} data-testid={dataTestid}>
      <div className="mx-auto max-w-350 text-right text-overline-1 text-white uppercase">
        {footerText ?? t(AdminPortalKeys.Footer_Copyright, { year: currentYear })}
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';
export { Footer };
